import React from 'react';
import { Smartphone, MessageCircle, Shield, List } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function FeaturesSection() {
  const features = [{
    icon: <List className="w-6 h-6 text-white" data-id="element-14" />,
    title: '7 Ideas de Side Hustle',
    desc: "Nada de 'Amazon FBA'. Son opciones reales que puedes hacer con tu celular, sin exhibirte y con demanda en México."
  }, {
    icon: <Smartphone className="w-6 h-6 text-white" data-id="element-15" />,
    title: 'Paso a paso sin tecnicismos',
    desc: 'Como una receta de cocina: ingredientes, pasos y tiempo. Qué apps bajar y cómo usarlas.'
  }, {
    icon: <MessageCircle className="w-6 h-6 text-white" data-id="element-16" />,
    title: 'Guiones de Venta',
    desc: 'Mensajes para presentarte sin sonar desesperada. Solo copias, pegas y adaptas tu nombre.'
  }, {
    icon: <Shield className="w-6 h-6 text-white" data-id="element-17" />,
    title: 'Seguridad y Límites',
    desc: 'Señales de alerta de estafas y cómo cuidar tus datos y fotos. Tu seguridad va primero.'
  }];
  return <section className="py-12 bg-white" data-id="element-18">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <div className="text-center mb-16" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-bold text-warm-900 mb-4" data-id="element-21">
            ¿Qué hay dentro de la guía?
          </h2>
          <p className="text-warm-600 max-w-2xl mx-auto" data-id="element-22">
            Todo lo que necesitas para pasar de la idea a la acción en una
            semana.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-12" data-id="element-23">
          {features.map((feature, idx) => <div key={idx} className="flex gap-6 p-6 rounded-2xl bg-warm-50 hover:bg-rose-50 transition-colors duration-300 border border-warm-100" data-id="element-24">
              <div className="shrink-0 w-12 h-12 bg-rose-500 rounded-xl flex items-center justify-center shadow-lg shadow-rose-200" data-id="element-25">
                {feature.icon}
              </div>
              <div data-id="element-26">
                <h3 className="text-xl font-bold text-warm-900 mb-2" data-id="element-27">
                  {feature.title}
                </h3>
                <p className="text-warm-600 leading-relaxed" data-id="element-28">{feature.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-29">
          <CTAButton onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-30">
            Ver la Guía Completa
          </CTAButton>
        </div>
      </div>
    </section>;
}